'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CodeEditor = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _FieldWrapper = require('../FieldWrapper/FieldWrapper');

var _FieldWrapper2 = _interopRequireDefault(_FieldWrapper);

var _CodeEditor = require('./CodeEditor.style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Helper function to dynamically load brace mode
 */
var loadMode = function loadMode(mode) {
  switch (mode) {
    case 'css':
      return require('brace/mode/css');
    case 'csharp':
      return require('brace/mode/csharp');
    case 'golang':
      return require('brace/mode/golang');
    case 'handlebars':
      return require('brace/mode/handlebars');
    case 'html':
      return require('brace/mode/html');
    case 'javascript':
      return require('brace/mode/javascript');
    case 'java':
      return require('brace/mode/java');
    case 'json':
      return require('brace/mode/json');
    case 'jsx':
      return require('brace/mode/jsx');
    case 'markdown':
      return require('brace/mode/markdown');
    case 'mysql':
      return require('brace/mode/mysql');
    case 'python':
      return require('brace/mode/python');
    case 'ruby':
      return require('brace/mode/ruby');
    case 'sass':
      return require('brace/mode/sass');
    case 'xml':
      return require('brace/mode/xml');
    default:
      return require('brace/mode/plain_text');
  }
};
/**
 * Helper function to dynamically load brace theme
 */
var loadTheme = function loadTheme(theme) {
  switch (theme) {
    default:
    case 'github':
      return require('brace/theme/github');
    case 'kuroir':
      return require('brace/theme/kuroir');
    case 'monokai':
      return require('brace/theme/monokai');
    case 'solarized_dark':
      return require('brace/theme/solarized_dark');
    case 'solarized_light':
      return require('brace/theme/solarized_light');
    case 'terminal':
      return require('brace/theme/terminal');
    case 'textmate':
      return require('brace/theme/textmate');
    case 'tomorrow':
      return require('brace/theme/tomorrow');
    case 'twilight':
      return require('brace/theme/twilight');
    case 'xcode':
      return require('brace/theme/xcode');
  }
};

/**
 * Code editor textarea input. Uses [react-ace](https://github.com/securingsincity/react-ace)
 * for component which utilizes [brace](https://github.com/thlorenz/brace)
 * [modes](https://github.com/thlorenz/brace/tree/master/mode) and
 * [themes](https://github.com/thlorenz/brace/tree/master/theme).
 * Please note that whis will not render server side. Take that into account
 * when using this component otherwise you may get checksum warnings.
 */
var CodeEditor = function CodeEditor(_ref) {
  var description = _ref.description,
      error = _ref.error,
      label = _ref.label,
      name = _ref.name,
      wrapperProps = _ref.wrapperProps,
      mode = _ref.mode,
      editorTheme = _ref.editorTheme,
      rest = (0, _objectWithoutProperties3.default)(_ref, ['description', 'error', 'label', 'name', 'wrapperProps', 'mode', 'editorTheme']);

  // Render Ace editor client side only!
  if (window !== undefined) {
    var AceEditor = require('react-ace').default;

    // Load formatting mode and theme
    loadMode(mode);
    loadTheme(editorTheme);

    return _react2.default.createElement(
      _FieldWrapper2.default,
      {
        description: description,
        error: error,
        label: label,
        labelFor: name,
        wrapperProps: wrapperProps
      },
      _react2.default.createElement(AceEditor, (0, _extends3.default)({}, rest, {
        mode: mode,
        name: name,
        theme: editorTheme
      }))
    );
  }

  // Render textarea
  return _react2.default.createElement('textarea', null);
};

exports.CodeEditor = CodeEditor;
CodeEditor.propTypes = {
  /**
   * className required by glamorous
   * @ignore
   */
  className: _propTypes2.default.string.isRequired,
  /**
   * Helper description for tooltip
   */
  description: _propTypes2.default.string,
  /**
   * Error message for input. Alters input style and displays error message if set.
   */
  error: _propTypes2.default.string,
  /**
   * Field label text to display above input
   */
  label: _propTypes2.default.string,
  /**
   * Props to pass on to the Input Component Wrapper.
   */
  wrapperProps: _propTypes2.default.object,
  /**
  * Unique ID for CodeEditor
  */
  name: _propTypes2.default.string,
  /**
   * Code formatting mode. This is only a small selection of available modes.
   * Please see https://github.com/thlorenz/brace/tree/master/mode for more.
   */
  mode: _propTypes2.default.oneOf(['css', 'csharp', 'golang', 'handlebars', 'html', 'javascript', 'java', 'json', 'jsx', 'markdown', 'mysql', 'python', 'ruby', 'sass', 'xml']),
  /**
   * CodeEditor theme. This is only a small selection of available themes.
   * Please see for https://github.com/thlorenz/brace/tree/master/theme more.
   */
  editorTheme: _propTypes2.default.oneOf(['github', 'kuroir', 'monokai', 'solarized_dark', 'solarized_light', 'terminal', 'textmate', 'tomorrow', 'twilight', 'xcode']),
  /**
   * Value of CodeEditor. If you set this you should also use onChange.
   */
  value: _propTypes2.default.string,
  /**
   * Default editor value
   */
  defaultValue: _propTypes2.default.string,
  /**
   * CSS value for editor height
   */
  height: _propTypes2.default.string,
  /**
   * CSS value for editor width
   */
  width: _propTypes2.default.string,
  /**
   * Pixel value for font size
   */
  fontSize: _propTypes2.default.number,
  /**
   * Show gutter
   */
  showGutter: _propTypes2.default.bool,
  /**
   * Show print margin
   */
  showPrintMargin: _propTypes2.default.bool,
  /**
   * Highlight active line
   */
  highlightActiveLine: _propTypes2.default.bool,
  /**
   * Whether to focus
   */
  focus: _propTypes2.default.bool,
  /**
   * the location of the cursor
   */
  cursorStart: _propTypes2.default.number,
  /**
   * Wrapping lines
   */
  wrapEnabled: _propTypes2.default.bool,
  /**
   * make the editor read only
   */
  readOnly: _propTypes2.default.bool,
  /**
   * Minimum number of lines to be displayed
   */
  minLines: _propTypes2.default.number,
  /**
   * Maximum number of lines to be displayed
   */
  maxLines: _propTypes2.default.number,
  /**
   * Enable basic autocompletion
   */
  enableBasicAutocompletion: _propTypes2.default.bool,
  /**
   * Enable live autocompletion
   */
  enableLiveAutocompletion: _propTypes2.default.bool,
  /**
   * Number of spaces for tabs
   */
  tabSize: _propTypes2.default.number,
  /**
   * Called on editor load
   */
  onLoad: _propTypes2.default.func,
  /**
   * Called before editor load
   */
  onBeforeLoad: _propTypes2.default.func,
  /**
   * Called on editor change. `(value, event) => {}`
   */
  onChange: _propTypes2.default.func,
  /**
   * Triggered on editor copy. `(selectedText) => {}`
   */
  onCopy: _propTypes2.default.func,
  /**
   * Triggered on editor paste. `(text) => {}`
   */
  onPaste: _propTypes2.default.func,
  /**
   * Triggered on selection change. `(selection, event) => {}`
   */
  onSelectionChange: _propTypes2.default.func,
  /**
   * Triggered on `focus` event
   */
  onFocus: _propTypes2.default.func,
  /**
   * Triggered on `blur` event
   */
  onBlur: _propTypes2.default.func,
  /**
   * Triggered on `scroll` event
   */
  onScroll: _propTypes2.default.func,
  /**
   * Triggered, when annotations change
   */
  onValidate: _propTypes2.default.func,

  // Additional Ace Props
  /**
   * @ignore
   */
  editorProps: _propTypes2.default.object,
  /**
   * @ignore
   */
  setOptions: _propTypes2.default.object,
  /**
   * @ignore
   */
  keyboardHandler: _propTypes2.default.string,
  /**
   * @ignore
   */
  commands: _propTypes2.default.array,
  /**
   * @ignore
   */
  annotations: _propTypes2.default.array,
  /**
   * @ignore
   */
  markers: _propTypes2.default.array,
  /**
   * @ignore
   */
  style: _propTypes2.default.object
};
CodeEditor.defaultProps = {
  mode: 'javascript',
  editorTheme: 'github',
  width: '100%',
  height: '500px',
  showGutter: true,
  showPrintMargin: true,
  highlightActiveLine: true,
  wrapEnabled: false,
  readOnly: false,
  enableBasicAutocompletion: false,
  enableLiveAutocompletion: false,
  tabSize: 2
};

exports.default = (0, _glamorous2.default)(CodeEditor)(_CodeEditor.defaultStyle, _CodeEditor.mapPropsAndThemeToStyle);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/form/CodeEditor/CodeEditor.js
// module id = 513
// module chunks = 0